// src/pages/UploadReport.jsx
import React, { useState } from "react";
import {
  Form,
  Button,
  Upload,
  DatePicker,
  message,
  Card,
  Typography,
  Space,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { uploadReport } from "../api/reportApi";

const { Title, Text } = Typography;
const { MonthPicker } = DatePicker;

const UploadReport = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = ({ fileList }) => {
    setFile(fileList && fileList.length > 0 ? fileList[0].originFileObj : null);
  };

  const handleSubmit = async (values) => {
    if (!file) {
      message.error("Por favor, seleccione un archivo Excel.");
      return;
    }

    const { monthYear } = values;
    const month = monthYear.month() + 1;
    const year = monthYear.year();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("month", month);
    formData.append("year", year);

    try {
      setLoading(true);
      await uploadReport(formData);
      message.success("Reporte subido exitosamente.");
    } catch (error) {
      message.error(
        error.response?.data?.error || "Error al subir el reporte."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        background: "#1f1f1f",
        color: "#ccc",
        minHeight: "calc(100vh - 80px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <Card
        style={{
          maxWidth: 600,
          width: "100%",
          background: "#2a2a2a",
          color: "#ccc",
          border: "1px solid #444",
        }}
        bordered={false}
      >
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <Title level={3} style={{ textAlign: "center", color: "#fff" }}>
            Subir Reporte Mensual
          </Title>
          <Text style={{ color: "#ccc" }}>
            Por favor, seleccione el mes y año del reporte, y cargue el archivo
            Excel correspondiente.
          </Text>

          <Form layout="vertical" onFinish={handleSubmit}>
            <Form.Item
              name="monthYear"
              label={<span style={{ color: "#ccc" }}>Mes y Año</span>}
              rules={[
                {
                  required: true,
                  message: "Por favor, seleccione el mes y año.",
                },
              ]}
            >
              <MonthPicker
                format="MM/YYYY"
                style={{ width: "100%" }}
                placeholder="Seleccionar mes y año"
              />
            </Form.Item>

            <Form.Item
              label={<span style={{ color: "#ccc" }}>Archivo Excel</span>}
              required
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange}
                accept=".xls,.xlsx"
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Seleccionar Archivo</Button>
              </Upload>
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Subir Reporte
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default UploadReport;
